/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
  init: (app) => {
    const toast = document.getElementById('toast');
    const toastClose = toast.querySelector('.toast-button');

    if (toast) {
      toastClose.addEventListener('click', () => {        
        toast.classList.remove('active');
        sessionStorage.setItem('toaster', 'closed');
      });
    }
  }
}

